import { DotsThreeVertical } from "@phosphor-icons/react";
import { ActionMenu } from "@/components/navigation/ActionMenu";
import { IconButton } from "@/components/primitives/Button";
import type { TableRowActionsProps } from "./DataTable.types";

export function TableRowActions<Row>({ row, getItems, label = "Row actions" }: TableRowActionsProps<Row>) {
  return (
    <ActionMenu
      trigger={<IconButton aria-label={label} icon={<DotsThreeVertical size={18} weight="bold" />} variant="ghost" size="sm" />}
      items={getItems(row)}
    />
  );
}
